import React from 'react';
import PropTypes from 'prop-types';

const Source = function ({ review }) {
  return (
    <section className="work-area fix-url-wrapping">
      <article>
        <p dir="auto">{review.source}</p>
      </article>
    </section>
  );
};

Source.propTypes = {
  review: PropTypes.object.isRequired,
};

export default Source;
